export default __webpack_public_path__ + "static/media/optionIcon.66d1d363.svg";